import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F0F0F0\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#A2001D\" d=\"M23.254 7.827H.746A12 12 0 0 0 0 12c0 1.468.264 2.874.746 4.174h22.508c.482-1.3.746-2.706.746-4.174s-.264-2.874-.746-4.174\"></path><path fill=\"#6DA544\" d=\"M12.033 24.001c4.11 0 7.737-2.067 9.9-5.217h-19.8a11.99 11.99 0 0 0 9.9 5.217M12.033 0c4.11 0 7.737 2.067 9.9 5.218h-19.8A11.99 11.99 0 0 1 12.033 0\"></path><path fill=\"#FFDA44\" d=\"m11.998 7.827 1.036 3.188h3.353l-2.713 1.971 1.037 3.189-2.713-1.97-2.712 1.97 1.036-3.189-2.713-1.97h3.353z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }